/**
 * @file The unanswered state of a home summary figure that holds no value:
 * an absent field, which predates the field, is refused `notConfigured` with
 * no key, and a refusal object keeps its code and key. Consumers:
 * `analyticsSummaryFigure` and `analyticsSummaryCount`, which handle the
 * answered value themselves, so no unanswered figure ever reads as zero.
 */
import type { Snapshot } from 'valtio';

import type { AnalyticsSummaryRefusedFigure } from '#types';

import type { AnalyticsUnansweredFigure } from './index.types';

export const analyticsSummaryUnansweredFigure = (
  figure: Snapshot<AnalyticsSummaryRefusedFigure> | undefined,
): AnalyticsUnansweredFigure =>
  figure === undefined
    ? {
        status: 'refused',
        answer: {
          status: 'refused',
          refusal: { refusal: 'notConfigured' },
          message: 'The home summary does not hold this figure.',
        },
      }
    : {
        status: 'refused',
        answer: {
          status: 'refused',
          refusal: { refusal: figure.refusal, key: figure.key },
          message: `The home summary figure was refused: ${figure.refusal}.`,
        },
      };
